const NAME = "PERMISSIONS_SETTINGS";

export default NAME;
